import { render } from "./customer_index.html?vue&type=template&id=03ed6a98&external"
import script from "./customer_index.js?vue&type=script&lang=js&external"
export * from "./customer_index.js?vue&type=script&lang=js&external"

import "@/assets/css/index.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__